export default __webpack_public_path__ + "static/media/control-palette.3a19ec15.svg";